import { render } from "./ReportMain.vue?vue&type=template&id=bcd60646&scoped=true"
import script from "./ReportMain.vue?vue&type=script&lang=js"
export * from "./ReportMain.vue?vue&type=script&lang=js"

import "./ReportMain.vue?vue&type=style&index=0&id=bcd60646&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd60646"]])

export default __exports__